import RightPopupComponent from "components/RightPopup";

import Avatar from "components/Avatar";
import InputPhone from "components/InputPhone";
import Button from "components/Button";

import MainInfo from "pages/client/components/editInfoPopup/components/mainInfo";
import Parking from "pages/client/components/editInfoPopup/components/parking";
import Pasport from "pages/client/components/editInfoPopup/components/pasport";
import PersonDelegateDate from "pages/client/components/editInfoPopup/components/personDelegateDate";
import ConfirmedPerson from "pages/client/components/editInfoPopup/components/confirmedPerson";
import ShowContent from "pages/client/components/editInfoPopup/components/showContent";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as ParkingIcon } from 'icons/pages/app/parking.svg';
import { ReactComponent as InsuranceCompanyIcon } from 'icons/pages/app/insuranceCompany.svg';
import { ReactComponent as AdvertIcon } from 'icons/pages/app/advert.svg';
import { ReactComponent as AdvertDisableIcon } from 'icons/pages/app/advertDisable.svg';

import './index.less';
import './themes/default.less';

export default class EditPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: {},
            checkSameAddress: false,
            birthCertificate: false,
            work: false,
            passport: false,
            recommendationTypes: [],
            customField: [],
            vehicles: [],
            mode: "edit",
            tempPhoto: false,
            modePark: 0,
            insuranceId: false,
            isPersonDelegateDate: false,
            isCommercialEnable: false
        };
    }

    get popupName() {
        return "editInfoPopup";
    }

    setInfoState(key, value) {
        this.state.info[key] = value;
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;
        this.setState({ info });
    }

    show(info, hideCb, mode) {
        this.state.info = { ...this.state.info, ...info };
        this.state.info.personalData = this.state.info.personalData || {};
        this.state.mode = mode;

        this.dialogTitle = mode !== "edit" ? "client.patientData" : "client.editingPatientData";

        this.hidCb = hideCb;

        const customField = (info.clientDynamicData && Object.keys(info.clientDynamicData).length > 0) ?
            Object.entries(info.clientDynamicData).map(([name, value]) => ({ name, value })) : [];

        this.setState({ customField });

        super.show();
    }

    async onShow() {
        const { info } = this.state;
        const { personalData, discount, visitPersonConfiguring, patientVehicle,
            insurance, personDelegateDate, commercialEnable } = info;

        if (this.inputRange)
            this.inputRange.value = discount ? discount : 0;

        const passport = personalData['PSP_SERIES'] || "";
        const birthCertificate = !!personalData['BC_SERIES'] || "";
        const confirmedPerson = !!visitPersonConfiguring || false;

        const recsResp = await this._request.recommendationTypes.getAll();
        const recommendationTypes = recsResp?.data || [];

        const checkSameAddress = personalData['REG_ADDRESS'] === personalData['ADDRESS'] ? true : false;
        if (this.selectReference)
            this.selectReference.value = this.state.info.knowAboutClinicDetails;

        const { vehicles, parkingPriority } = (patientVehicle || {});
        const modePark = (!parkingPriority || parkingPriority === "NOT_NECESSARY") ? 0 :
            parkingPriority === "REQUIRED" ? 1 : 2;

        const insuranceId = insurance?.id || false;
        const isPersonDelegateDate = personDelegateDate ? true : false;
        const isCommercialEnable = Object.keys(commercialEnable || {}).some(it => commercialEnable[it]);

        this.setState({
            recommendationTypes, passport, birthCertificate, checkSameAddress, confirmedPerson,
            vehicles, modePark, insuranceId, isPersonDelegateDate, isCommercialEnable
        });
    }

    formUpdateInfo() {
        const { customField, info, vehicles, modePark, insuranceId } = this.state;
        const { status, lname, sname, fname, birthday, sex, vipStatus, phoneNumber, smileKeeper,
            isEmployee, phoneWorkingNumber, personalData, discount, lkSearchAttr1, photoUid,
            cityId, notificationTypeEnable, egiszPublishEnable, visitPersonConfiguring, isGratitude,
            insuranceComp, contactData, commercialEnable, personDelegateDate, statusTreatment } = info;

        const clientDynamicData = customField?.reduce((obj, { name, value }) => {
            obj[name] = value;
            return obj;
        }, {});

        const knowAboutClinicDetails = this.selectReference.value;

        const patientVehicle = {
            parkingPriority: modePark === 0 ? "NOT_NECESSARY" : modePark === 1 ? "REQUIRED" : "NOT_CLARIFIED",
            vehicles
        };

        const insurance = insuranceComp.find(it => it.id === insuranceId);

        if (personDelegateDate?.issueDatePSP) {
            const arr = personDelegateDate.issueDatePSP.split(".");
            if (arr?.length === 3)
                personDelegateDate.issueDatePSP = `${arr[2]}-${arr[1]}-${arr[0]}`;
        }

        const inId = insuranceId ? insuranceId : null;

        const obj = {
            status, lname, sname, fname, birthday, sex, vipStatus, phoneNumber, clientDynamicData,
            notificationTypeEnable, smileKeeper, phoneWorkingNumber, personalData, discount,
            lkSearchAttr1, photoUid, knowAboutClinicDetails, cityId, isEmployee, egiszPublishEnable,
            visitPersonConfiguring, patientVehicle, insurance, contactData, commercialEnable,
            personDelegateDate, statusTreatment, isGratitude, insuranceId: inId
        };

        obj.knowAboutClinicDetails = this.selectReference.value;

        return obj;
    }

    async save() {
        const { mode, tempPhoto, info: infoClient } = this.state;

        if (mode === "view")
            return this.hide();

        const info = this.formUpdateInfo();

        if (info.lname && info.fname /* && info.cityId*/) {
            this.hide();

            if (tempPhoto && infoClient.id) {
                const infoFile = {
                    fileInfo: { image: tempPhoto, name: tempPhoto.name },
                };
                await this._request.images.uploadAvatar(infoClient.id, infoFile);
            }

            if (this.hidCb?.apply)
                this.hidCb(info);

        } else if (!info.fname) {
            this.showError("client.errorfname");
            this.fnameInput.setFocus();
        } else {
            this.showError("client.errorlname");
            this.lnameInput.setFocus();
        }

    }

    onClickCheck(value) {
        this.changeInfoState("vipStatus", value);
    }

    onClickSameAddress(value) {
        const { personalData } = this.state.info;
        if (!value)
            personalData['ADDRESS'] = personalData['REG_ADDRESS'];
        this.changeState("checkSameAddress", !value);
    }

    onChangeAddres(type, value) {
        const { personalData } = this.state.info;
        personalData[type] = value;
        if ((personalData['ADDRESS'] === value && type === "REG_ADDRESS") || (personalData['REG_ADDRESS'] === value && type === "ADDRESS"))
            this.changeState("checkSameAddress", true);
        else
            this.changeState("checkSameAddress", false);
    }

    onMode() {
        this.dialogTitle = "client.editingPatientData";
        this.changeState("mode", "edit");
    }

    insertInputs(props, props2, props3) {
        return (
            <div className="inputs flex gap16">
                {this.insertInput(props)}
                {this.insertInput(props2)}
                {props3 && this.insertInput(props3)}
            </div>
        );
    }

    getClearLabel(value) {
        return (
            <div className="rangeText flex centerV gap8">
                <div className="text p1SemiBold">{this.tr("client.discount")}</div>
                {/*<div className="text p1">{`${value ? value : 0}%`}</div>*/}
            </div>
        );
    }

    changeDiscount(value) {
        this.changeInfoState("discount", value ? value : 0);
    }

    addCustomField() {
        const { customField } = this.state;
        this.changeState("customField", [...customField, { name: "", value: "" }]);
    }

    addVehicles() {
        const { vehicles } = this.state;
        this.changeState("vehicles", [...(vehicles || []), { mark: "", number: "" }]);
    }

    updateCustomField(id, source, value) {
        const { customField } = this.state;
        const newName = customField.map((it, i) => (i === id ? { ...it, [source]: value } : it));
        this.state.customField = [...newName];
    }

    updateVehicles(id, source, value) {
        const { vehicles } = this.state;
        const newName = (vehicles || []).map((it, i) => (i === id ? { ...it, [source]: value } : it));
        this.state.vehicles = [...newName];
    }

    removeCustomField(id) {
        const { customField } = this.state;
        this.changeState("customField", [...customField.filter((_, i) => i !== id)]);
    }

    removeVehicles(id) {
        const { vehicles } = this.state;
        this.changeState("vehicles", [...vehicles.filter((_, i) => i !== id)]);
    }

    getSexByName(lname, fname) {
        const value = lname || fname;
        if (!value)
            return null;

        const last = value.at(-1);
        return (last === "а" || last === "я") ? 1 : 0;
    }

    onChangeSex(value) {
        /*const sex = {
            0: "MALE",
            1: "FEMALE"
        };*/
        //this.changeInfoState("sex", (value === 0 || value === 1) ? sex[value] : "NA");
        this.changeInfoState("sex", value);
    }

    onChangeLName(value) {
        const { fname } = this.state.info;
        this.state.info.lname = value;
        const sex = this.getSexByName(value, fname) ? "FEMALE" : "MALE";
        this.changeInfoState("sex", sex);
    }

    onChangeFName(value) {
        const { lname } = this.state.info;
        this.state.info.fname = value;
        const sex = this.getSexByName(lname, value) ? "FEMALE" : "MALE";
        this.changeInfoState("sex", sex);
    }

    onChangeSName(value) {
        this.state.info.sname = value;
    }

    onChangeDateBirth(value) {
        this.state.info.birthday = value;
    }

    onChangePersonalDate(source, value) {
        this.state.info.personalData[source] = value;
    }

    onChangePhone(source, value) {
        if (value === "+")
            value = "";
        if (source === "phoneNumber")
            this.state.info.phoneNumber = value;
        else if (source === "workPhone")
            this.state.info.phoneWorkingNumber = value;
        else
            this.state.info.personalData['PHONE_1'] = value;

    }

    renderBirthCertificate(birthCertificate, data) {
        const active = birthCertificate ? "active" : "";
        return (
            <div className={`birthCertificate flex col gap16 ${active}`}>
                <div className="flex1 flex gap8">
                    <div className="flex gap1" style={{ flex: 2 }}>
                        {this.insertInput({
                            ref: el => this.dbSeriesInput = el,
                            value: data['BC_SERIES'],
                            itemStyle: "flex1",
                            label: "client.series",
                            placeHolder: "XXX-XX",
                            onChange: this.onChangePersonalDate.bind(this, "BC_SERIES")
                        })}
                        {this.insertInput({
                            ref: el => this.dbNumberInput = el,
                            value: data['BC_NUMBER'],
                            itemStyle: "flex1",
                            label: "client.number",
                            placeHolder: "000000",
                            onChange: this.onChangePersonalDate.bind(this, "BC_NUMBER")
                        })}
                    </div>
                    <div style={{ flex: 1 }}>
                        {this.insertInput({
                            ref: el => this.dbWhenIssuedInput = el,
                            value: data['BC_ISSUE_DATE'],
                            itemStyle: "flex1",
                            label: "client.whenIssued",
                            validator: this._helper.inputValidators.date,
                            placeHolder: "01.01.2000",
                            onChange: this.onChangePersonalDate.bind(this, "BC_ISSUE_DATE")
                        })}
                    </div>
                </div>
                <div className="inputFull">
                    {this.insertInput({
                        ref: el => this.dbWhenIssuedByInput = el,
                        value: data['BC_ISSUED_BY'],
                        itemStyle: "flex1",
                        label: "client.issuedBy",
                        validator: this._helper.inputValidators.capitalize,
                        placeHolder: "client.nameIssued",
                        onChange: this.onChangePersonalDate.bind(this, "BC_ISSUED_BY")
                    })}
                </div>

            </div>
        );
    }

    changeVisitPersonConfiguring(info, key, val) {
        this.changeInfoState("visitPersonConfiguring", { ...info, [key]: val });
    }

    onChangeAvatar(selectedFile) {
        this.changeState("tempPhoto", selectedFile);
    }

    openDialogAvatarUpload(info) {
        this._helper.openDialog("avatarUpload", info, this.onChangeAvatar.bind(this));
    }

    onChangeContactDate(source, cd, val) {
        if (source === "usernameText") {
            this.changeInfoState("contactData", { ...cd, telegramUserName: val });
        } else if (source === "telegramUserName") {
            this.changeInfoState("contactData", { ...cd, telegramUserName: val === 1 ? undefined : "" });
        } else
            this.changeInfoState("contactData", { ...cd, [source]: cd[source] ? false : true });
    }

    onChangeCommercialEnable(source, ce) {
        this.changeInfoState("commercialEnable", { ...ce, [source]: ce[source] ? false : true });
    }

    onChangePersonDelegateDate(source, val) {
        const { personDelegateDate: pd } = this.state.info;
        this.changeInfoState("personDelegateDate", { ...pd, [source]: val });
    }

    renderViewText(title, value) {
        return (<div className="flex col gap16 flex1">
            <div className="viewTitle text p2">{this.tr(title)}</div>
            <div className="viewText text p1">{value}</div>
        </div>);
    }

    renderButtons() {
        const { mode } = this.state;

        if (mode === "edit")
            return super.renderButtons();

        return (
            <div className="buttons flex end">
                <div className="flex ">
                    <Button
                        label="main.close"
                        size="small"
                        onClick={this.save.bind(this)}
                    />
                </div>
            </div>
        );

    }

    renderAvatar() {
        const { mode, info, tempPhoto } = this.state;
        const { photoUid, sex } = info;

        return (<div className="flex gap16">
            <Avatar
                id={photoUid}
                tempPhoto={tempPhoto ? URL.createObjectURL(tempPhoto) : false}
                sex={sex}
                size={120}
                radius={8}
                iconWidth={120}
                iconHeight={120}
            />
            {mode === "edit" ? <div className="flex gap16">
                <div className="buttonIcon">
                    {photoUid ? this.insertButtonIcon({
                        name: "trash",
                        /*tooltip: "main.uploadFile",*/
                        onClick: null
                    }) : <></>}
                </div>
                <div >
                    {this.insertButton({
                        type: "secondary",
                        size: "small",
                        onClick: this.openDialogAvatarUpload.bind(this, info),
                        label: "client.replacePhoto"
                    })}
                </div>
            </div> : <div>{this.insertButtonIcon({
                name: "edit",
                onClick: this.onMode.bind(this)
            })}</div>}
        </div>);
    }

    setValueRadio(el, answer) {
        if (el && answer)
            el.value = answer;
    }

    renderContactData(contactData) {
        const cd = (contactData || {});
        const { whatsappEnable, smsEnable, phoneEnable, telegramEnable, telegramUserName } = cd;

        return (<div className="flex col gap16">
            {this.insertCheckBox({
                checked: whatsappEnable,
                title: "WhatsApp",
                onClick: this.onChangeContactDate.bind(this, "whatsappEnable", cd)
            })}
            <div>
                {this.insertCheckBox({
                    checked: telegramEnable,
                    title: "Telegram",
                    onClick: this.onChangeContactDate.bind(this, "telegramEnable", cd)
                })}
                {telegramEnable && <div className="wrapTelegram flex col gap8">
                    {this.insertRadioBlock({
                        ref: el => this.setValueRadio(el, (telegramUserName === undefined || telegramUserName === null) ? 1 : 2),
                        items: [{
                            key: 1,
                            name: "Аккаунт Telegram по номеру телефона",
                            value: 1,
                        }, {
                            key: 2,
                            name: "Имя пользователя в Telegram",
                            value: 2,
                        }],
                        onChange: this.onChangeContactDate.bind(this, "telegramUserName", cd)
                    })}
                    {telegramUserName !== undefined && this.insertInput({
                        value: telegramUserName,
                        itemStyle: "flex1 username",
                        placeHolder: "@username",
                        onChange: this.onChangeContactDate.bind(this, "usernameText", cd)
                    })}
                </div>}
            </div>
            {this.insertCheckBox({
                checked: smsEnable,
                title: "SMS",
                onClick: this.onChangeContactDate.bind(this, "smsEnable", cd)
            })}
            {this.insertCheckBox({
                checked: phoneEnable,
                title: "Звонок",
                onClick: this.onChangeContactDate.bind(this, "phoneEnable", cd)
            })}
        </div>);
    }

    renderCommercialEnable(commercialEnable, isCommercialEnable) {
        const ce = (commercialEnable || {});
        const { whatsapp, sms, phone, push, telegram, email } = ce;
        const active = isCommercialEnable ? "active" : "";
        return (<div className={`commercialEnable flex col gap16 ${active}`}>
            {this.insertCheckBox({
                checked: whatsapp,
                title: "WhatsApp",
                onClick: this.onChangeCommercialEnable.bind(this, "whatsapp", ce)
            })}
            {this.insertCheckBox({
                checked: telegram,
                title: "Telegram",
                onClick: this.onChangeCommercialEnable.bind(this, "telegram", ce)
            })}
            {this.insertCheckBox({
                checked: sms,
                title: "SMS",
                onClick: this.onChangeCommercialEnable.bind(this, "sms", ce)
            })}
            {this.insertCheckBox({
                checked: phone,
                title: "Звонок",
                onClick: this.onChangeCommercialEnable.bind(this, "phone", ce)
            })}
            {this.insertCheckBox({
                checked: email,
                title: "Email",
                onClick: this.onChangeCommercialEnable.bind(this, "email", ce)
            })}
            {this.insertCheckBox({
                checked: push,
                title: "Push-уведомления в приложении",
                onClick: this.onChangeCommercialEnable.bind(this, "push", ce)
            })}
        </div>);
    }

    renderShowContent() {
        const { info, recommendationTypes, customField } = this.state;

        return (<ShowContent
            info={info}
            renderAvatar={this.renderAvatar.bind(this)}
            recommendationTypes={recommendationTypes}
            customField={customField} />);
    }

    renderContent() {
        const { info, birthCertificate, work, passport, customField, mode, isPersonDelegateDate,
            confirmedPerson, modePark, vehicles, insuranceId, checkSameAddress,
            isCommercialEnable } = this.state;
        const cities = this._helper.getCities();

        const { discount, phoneWorkingNumber, personalData: pd, cityId, city,
            visitPersonConfiguring, egiszPublishEnable, insuranceComp,
            contactData, commercialEnable, personDelegateDate } = info;

        const personalData = (pd || {});

        const showAdvertIcon = Object.keys(commercialEnable || {}).some(it => commercialEnable[it]);

        return (mode !== "edit" ? this.renderShowContent() :
            <div className="flex gap24 col" style={{ width: "416px" }}>
                <MainInfo
                    info={info}
                    onChangeLName={this.onChangeLName.bind(this)}
                    onChangeFName={this.onChangeFName.bind(this)}
                    onChangeSName={this.onChangeSName.bind(this)}
                    onChangeDateBirth={this.onChangeDateBirth.bind(this)}
                    onChangeSex={this.onChangeSex.bind(this)}
                    renderAvatar={this.renderAvatar.bind(this)}
                    setInfoState={this.setInfoState.bind(this, "status")}
                    setTreatmentStatus={this.setInfoState.bind(this, "statusTreatment")}
                    onChangePhone={this.onChangePhone.bind(this)}
                    changeInfoState={this.changeInfoState.bind(this)}
                    onChangePersonalDate={this.onChangePersonalDate.bind(this)}
                />
                {this.insertLine()}
                <div className="flex col gap16">
                    {this.insertToggleSwitch({
                        checked: !!confirmedPerson,
                        textBold: true,
                        label: "Визиты подтверждает другой человек",
                        onChange: this.changeState.bind(this, "confirmedPerson")
                    })}
                    <ConfirmedPerson
                        confirmedPerson={confirmedPerson}
                        visitPersonConfiguring={visitPersonConfiguring}
                        changeVisitPersonConfiguring={this.changeVisitPersonConfiguring.bind(this)}
                    />
                </div>
                {this.insertLine()}
                <div className="flex col gap16">
                    <div className="flex gap8">
                        {this.insertParagraf("Парковка")}
                        <ParkingIcon />
                    </div>
                    <Parking
                        vehicles={vehicles}
                        changeModePark={this.changeState.bind(this, "modePark")}
                        modePark={modePark}
                        addVehicles={this.addVehicles.bind(this)}
                        removeVehicles={this.removeVehicles.bind(this)}
                        updateVehicles={this.updateVehicles.bind(this)}
                    />
                </div>
                {this.insertLine()}
                <div className="flex1 flex col gap8">
                    {this.getClearLabel(discount)}
                    {this.insertInputRange({
                        ref: el => this.inputRange = el,
                        items: ["0", "5", "10", "15", "20", "25", "50", "75", "100"],
                        prefix: "%",
                        onChange: this.changeDiscount.bind(this)
                    })}
                </div>
                {this.insertLine()}
                {this.insertToggleSwitch({
                    checked: egiszPublishEnable,
                    textBold: true,
                    label: "Передавать данные в ЕГИСЗ",
                    onChange: this.changeInfoState.bind(this, "egiszPublishEnable", !egiszPublishEnable)
                })}
                {this.insertLine()}
                <div className="flex col gap16">
                    <div className="flex gap8">
                        {this.insertParagraf("СНИЛС и страхование")}
                        <InsuranceCompanyIcon />
                    </div>
                    <div className="flex flex1 gap16">
                        {this.insertInput({
                            ref: el => this.snils = el,
                            itemStyle: "flex1",
                            value: personalData['SNILS'],
                            label: "СНИЛC",
                            placeHolder: "000-000-000-00",
                            format: "xxx-xxx-xxx-xx",
                            validator: this._helper.inputValidators.format,
                            onChange: this.onChangePersonalDate.bind(this, "SNILS")
                        })}
                        {this.insertInput({
                            value: personalData['OMS'],
                            itemStyle: "flex1",
                            label: "client.policy",
                            placeHolder: "0000 0000 0000 0000",
                            onChange: this.onChangePersonalDate.bind(this, "OMS")
                        })}
                    </div>
                    <div className="flex gap16">
                        {this.insertSelect({
                            translate: true,
                            label: "Страховая компания ДМС",
                            itemStyle: "flex1",
                            value: insuranceId,
                            placeHolder: "client.fieldNotFilled",
                            showLeftIcon: false,
                            items: insuranceComp,
                            onChange: this.changeState.bind(this, "insuranceId")
                        })}
                        {this.insertInput({
                            value: personalData['DMS'],
                            itemStyle: "flex1",
                            label: "client.vhiPolicy",
                            placeHolder: "XXX№000000",
                            onChange: this.onChangePersonalDate.bind(this, "DMS")
                        })}
                    </div>
                    <div className="flex">
                        {this.insertInput({
                            value: personalData['CONTRACT'],
                            itemStyle: "flex1",
                            label: "Номер договора ДМС",
                            placeHolder: "№00000 от 01.01.2000",
                            onChange: this.onChangePersonalDate.bind(this, "CONTRACT")
                        })}
                        <div className="flex1"></div>
                    </div>

                </div>
                {this.insertLine()}
                {this.insertToggleSwitch({
                    checked: !!work,
                    textBold: true,
                    label: "main.work",
                    onChange: this.changeState.bind(this, "work")
                })}
                {work && <div className="flex col gap16">
                    <div className="flex flex1 gap16">
                        <InputPhone
                            value={phoneWorkingNumber}
                            itemStyle="flex1"
                            label="client.workPhone"
                            onChange={this.onChangePhone.bind(this, "workPhone")}
                        />
                        <div className="flex flex1"></div>
                    </div>
                    {this.insertInputs({
                        value: personalData['JOB_PLACE'],
                        itemStyle: "flex1",
                        label: "client.placeWork",
                        placeHolder: "client.nameOrg",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.onChangePersonalDate.bind(this, "JOB_PLACE")
                    }, {
                        value: personalData['JOB_KIND'],
                        itemStyle: "flex1",
                        label: "client.kindActivity",
                        placeHolder: "client.post",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.onChangePersonalDate.bind(this, "JOB_KIND")
                    })}
                </div>}
                {this.insertLine()}
                {this.insertParagraf("Адрес")}
                <div className="inputFull">
                    {this.insertInput({
                        value: pd['REG_ADDRESS'],
                        itemStyle: "flex1",
                        label: "client.registrAddress",
                        placeHolder: "client.exampleAddress",
                        onChange: this.onChangeAddres.bind(this, "REG_ADDRESS")
                    })}
                </div>
                {this.insertCheckBox({
                    checked: checkSameAddress,
                    title: "client.sameHomeAddress",
                    onClick: this.onClickSameAddress.bind(this, checkSameAddress)
                })}
                <div className="inputFull">
                    {this.insertInput({
                        value: pd['ADDRESS'],
                        itemStyle: "flex1",
                        label: "client.homeAddress",
                        placeHolder: "client.exampleAddress",
                        onChange: this.onChangeAddres.bind(this, "ADDRESS")
                    })}
                </div>я
                {this.insertLine()}
                <div className="flex col gap16">
                    {this.insertToggleSwitch({
                        checked: !!birthCertificate,
                        textBold: true,
                        label: "client.birthCertificate",
                        onChange: this.changeState.bind(this, "birthCertificate")
                    })}
                    {this.renderBirthCertificate(birthCertificate, personalData)}
                </div>
                {this.insertLine()}
                <div className="flex col gap16">
                    {this.insertToggleSwitch({
                        checked: !!passport,
                        label: "client.passport",
                        onChange: this.changeState.bind(this, "passport")
                    })}
                    <Pasport
                        passport={passport}
                        data={personalData}
                        onChangePersonalDate={this.onChangePersonalDate.bind(this)}
                    />
                </div>
                {this.insertLine()}
                <div className="flex col gap16">
                    {this.insertToggleSwitch({
                        checked: isPersonDelegateDate,
                        label: "Законный представитель",
                        onChange: this.changeState.bind(this, "isPersonDelegateDate")
                    })}
                    <PersonDelegateDate
                        passport={passport}
                        isPersonDelegateDate={isPersonDelegateDate}
                        data={personDelegateDate}
                        onChangePersonDelegateDate={this.onChangePersonDelegateDate.bind(this)}
                    />
                </div>
                {this.insertLine()}
                {this.insertSelect({
                    translate: true,
                    label: "client.city",
                    value: cityId ? cityId : city?.id,
                    placeHolder: "client.fieldNotFilled",
                    showLeftIcon: false,
                    items: cities,
                    onChange: this.changeInfoState.bind(this, "cityId")
                })}
                {this.insertLine()}
                {this.insertParagraf("Канал для уведомлений о приёме")}
                {this.renderContactData(contactData)}
                {this.insertLine()}
                <div className="flex col gap16">
                    {this.insertToggleSwitch({
                        checked: isCommercialEnable,
                        textBold: true,
                        icon: showAdvertIcon ? <AdvertIcon /> : <AdvertDisableIcon />,
                        label: "Рекламные рассылки",
                        onChange: this.changeState.bind(this, "isCommercialEnable")
                    })}
                    {this.renderCommercialEnable(commercialEnable, isCommercialEnable)}
                </div>
                {this.insertLine()}
                {this.insertParagraf("client.emergencyComm")}
                <div className="flex flex1 gap1">
                    <div className="flex" style={{ flex: 1 }}>
                        <InputPhone
                            value={personalData['SOS_PHONE']}
                            label="client.telandcont"
                            placeHolder="+7 900 000-00-00"
                            onChange={this.onChangePersonalDate.bind(this, "SOS_PHONE")}
                        />
                    </div>
                    <div style={{ flex: 2 }}>
                        {this.insertInput({
                            ref: el => this.sosContactInput = el,
                            value: personalData['SOS_CONTACT'],
                            label: ".",
                            placeHolder: "client.nameWhom",
                            validator: this._helper.inputValidators.capitalize,
                            onChange: this.onChangePersonalDate.bind(this, "SOS_CONTACT")
                        })}
                    </div>
                </div>
                <div className="inputFull">
                    {this.insertInput({
                        ref: el => this.nameParentsInput = el,
                        value: personalData['PARENTS_NAME'],
                        itemStyle: "flex1",
                        label: "client.nameParents",
                        placeHolder: "client.exampleParents",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: this.onChangePersonalDate.bind(this, "PARENTS_NAME")
                    })}
                </div>
                {this.insertLine()}
                {this.insertSelectReference({
                    ref: el => this.selectReference = el,
                })}
                {this.insertLine()}
                {customField?.map((it, i) => (<div key={"field_" + i} className="flex gap16">
                    <div className="flex w100">
                        {this.insertInput({
                            value: it.name,
                            itemStyle: "flex1",
                            placeHolder: "client.fieldName",
                            onChange: this.updateCustomField.bind(this, i, "name")
                        })}
                        {this.insertInput({
                            value: it.value,
                            itemStyle: "flex1",
                            placeHolder: "client.fieldValue",
                            onChange: this.updateCustomField.bind(this, i, "value")
                        })}
                    </div>
                    <div className="flex centerV" onClick={this.removeCustomField.bind(this, i)}>
                        <CloseIcon className="close hand" />
                    </div>
                </div>))}
                <div className="addNewField botmarg flex gap8 text p1 hand" onClick={this.addCustomField.bind(this)}>
                    <PlusIcon />
                    <div className="addNewFieldTitle">
                        {this.tr("client.addNewField")}
                    </div>
                </div>
            </div>
        );
    }
}

